import { createDosespotClinician } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  CreateDosespotClinicianRequestT,
  DosespotClinicianRecordT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

/**
 * Create a new DoseSpot clinician record for a user.
 */
export async function fetchCreateDosespotClinician(
  data: CreateDosespotClinicianRequestT,
  signal?: AbortSignal
): Promise<DosespotClinicianRecordT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await createDosespotClinician(data, config);
  return lotusHealthZod.createDosespotClinicianResponse.parse(
    response.data
  ) as DosespotClinicianRecordT;
}
